import { db } from '../firebase_config';
import {useState , useEffect} from 'react';

const useFirestore = (collection) =>{

    const [docs, setDocs] = useState([]);

    useEffect(()=> {
        const unsub = db.collection(collection)
        .orderBy('createdAt','desc')
        .onSnapshot((snap) => {
            let documents = [];
            snap.forEach(doc => {
                documents.push({...doc.data(),id: doc.id});
            });
            setDocs(documents);
        });

        return()=> unsub();
    },[collection ])

    return {docs};
}


export default useFirestore;